import { FunctionComponent } from 'react'
import CloseIcon from './CloseIcon'
import HowToPlayIcon from './HowToPlayIcon'
import MenuIcon from './MenuIcon'
import SettingsIcon from './SettingsIcon'
import StatisticsIcon from './StatisticsIcon'

export type IconName = 'menu' | 'how-to-play' | 'close' | 'settings' | 'statistics'

export type Props = {
	iconName: IconName
}

const IconComponents: Record<IconName, FunctionComponent> = {
	'how-to-play': HowToPlayIcon,
	close: CloseIcon,
	menu: MenuIcon,
	settings: SettingsIcon,
	statistics: StatisticsIcon,
}

const Icon = (props: Props) => {
	const IconComponent = IconComponents[props.iconName]
	return <IconComponent />
}

export default Icon
